<template>
    <div v-if="hasTabs" class="vue-tabs-component">
        <ul class="tab-buttons list-style-none d-flex justify-content-center">
            <li v-for="tab in tabs" :id="tab.id" class="vue-tab-button">
                <dentaid-tab-button @selected-tab="handleSelectedTab" :item="tab" :selected-id="selectedId"></dentaid-tab-button>
            </li>
        </ul>

        <div v-for="(tab, index) in tabs" :key="index" v-if="tab.id === selectedId" :aria-labelledby="tab.id" class="tab-content text-formatted">
            <div class="tab-text container" v-html="tab.text"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TabsComponent",

    props: {
        tabs: {
            required: true,
            type: Array
        }
    },

    data() {
        return {
            selectedId: null,
        }
    },

    computed: {
        hasTabs() {
            return !_.isEmpty(this.tabs);
        }
    },

    mounted() {
        this.setDefaultTab();
    },

    methods: {
        handleSelectedTab(payload) {
            this.selectedId = payload;
        },

        setDefaultTab() {
            if (!this.hasTabs) {
                return;
            }

            const firstTab = _.head(this.tabs);

            this.selectedId = firstTab.id;
        }
    }
}
</script>

<style>
@import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css';
</style>
